import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Seo } from "../../components/Seo";

export function NotFoundPage() {
  return (
    <>
      <Seo title="Story moved | ZimSmart" />
      <div className="page-wrap not-found-page">
        <span className="eyebrow">404</span>
        <h1>Looks like this story has moved.</h1>
        <p>Search the magazine or return home to continue reading.</p>
        <div className="not-found-actions">
          <Link className="button" to="/search">
            <Search size={16} />
            Search
          </Link>
          <Link className="button ghost" to="/">
            Home
          </Link>
        </div>
      </div>
    </>
  );
}
